import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-50" aria-labelledby="categories-heading">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 id="categories-heading" className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            探索文字世界
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            六大分类板块，满足你对文字的所有想象。选择你感兴趣的领域，开始你的文字之旅。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-100 rounded-lg p-5 md:p-6 hover:bg-primary-50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${cat.icon} text-lg text-primary-600 w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-300">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}